import React, { useState } from 'react';
import useSound from 'use-sound';
import 'animate.css';
import './App.css';
import GameContext, { defaultGameState, GameState, Sounds } from './context/GameContext';
import GameRouter from './views/GameRouter';
import { CharacterSeed } from './views/avatar/Avatar';
import controlMusicOn from './media/control-music-on.png';
import controlMusicOff from './media/control-music-off.png';

interface AppProps {}

const App = (props: AppProps) => {
    const [gameState, setGameState] = useState<GameState>(defaultGameState);

    const [playBackgroundMusic, backgroundMusicControls] = useSound(
        `${process.env.PUBLIC_URL}/sounds/experience/background-music.mp3`,
        {
            volume: 1,
            loop: true,
            interrupt: true,
        }
    );

    const [playLoginIntro, loginIntroControls] = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/lobby__intro.mp3`, {
        volume: 1,
        loop: false,
        interrupt: true,
    });

    const [playAvatarMusic, avatarMusicControls] = useSound(
        `${process.env.PUBLIC_URL}/sounds/experience/avatar__background-music.mp3`,
        {
            volume: 1,
            interrupt: true,
            loop: true,
        }
    );

    const [playCuencaBajaIntro, cuencaBajaIntroControls] = useSound(
        `${process.env.PUBLIC_URL}/sounds/dialogs/cuenca_baja__intro.mp3`,
        {
            volume: 1,
            interrupt: true,
            loop: false,
        }
    );

    const [playCuencaMediaIntro, cuencaMediaIntroControls] = useSound(
        `${process.env.PUBLIC_URL}/sounds/dialogs/cuenca_media__intro.mp3`,
        {
            volume: 1,
            interrupt: true,
            loop: false,
        }
    );

    const [playCuencaAltaIntro, cuencaAltaIntroControls] = useSound(
        `${process.env.PUBLIC_URL}/sounds/dialogs/cuenca_alta__intro.mp3`,
        {
            volume: 1,
            interrupt: true,
            loop: false,
        }
    );

    const [playGlaciarIntro, glaciarIntroControls] = useSound(
        `${process.env.PUBLIC_URL}/sounds/dialogs/glaciar__intro.mp3`,
        {
            volume: 1,
            interrupt: true,
            loop: false,
        }
    );

    const sq__ca_2 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__ca_2.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__ca_3 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__ca_3.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__ca_familias = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__ca_familias.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cm_descubrir = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cm_descubrir.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cm_lideres = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cm_lideres.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cm_potencial = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cm_potencial.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cm_sectores = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cm_sectores.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cb_3 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cb_3.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cb_desemboca = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cb_desemboca.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__cb_nacimiento = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__cb_nacimiento.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_1 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_1.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_2 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_2.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_3 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_3.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_6 = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_6.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_color = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_color.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_glaciologia = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_glaciologia.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_preocupacion = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_preocupacion.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const sq__gl_sistema = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/sq__gl_sistema.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => backgroundMusicControls.stop(),
        onend: () => playBackgroundMusic(),
    });

    const skin__danta = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/skin__danta.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => avatarMusicControls.stop(),
        onend: () => playAvatarMusic(),
    });

    const skin__monkey = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/skin__monkey.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => avatarMusicControls.stop(),
        onend: () => playAvatarMusic(),
    });

    const skin__turkey = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/skin__turkey.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => avatarMusicControls.stop(),
        onend: () => playAvatarMusic(),
    });

    const skin__bird = useSound(`${process.env.PUBLIC_URL}/sounds/dialogs/skin__bird.mp3`, {
        volume: 1,
        interrupt: true,
        loop: false,
        onplay: () => avatarMusicControls.stop(),
        onend: () => playAvatarMusic(),
    });

    const [playPop] = useSound(`${process.env.PUBLIC_URL}/sounds/experience/pop.mp3`, {
        volume: 1,
    });

    const [playSuccess] = useSound(`${process.env.PUBLIC_URL}/sounds/experience/success.mp3`, {
        volume: 1,
    });

    const [playFail] = useSound(`${process.env.PUBLIC_URL}/sounds/experience/fail.mp3`, {
        volume: 1,
    });

    const [playVictory] = useSound(`${process.env.PUBLIC_URL}/sounds/experience/victory.mp3`, {
        volume: 1,
    });

    const handleMainSound = (action: Sounds) => {
        switch (action) {
            case 'play-background-music':
                if (!backgroundMusicControls?.sound?.playing()) playBackgroundMusic();
                break;

            case 'stop-background-music':
                if (backgroundMusicControls) backgroundMusicControls.stop();
                break;

            case 'level-down-background-music':
                backgroundMusicControls?.sound?.fade(1, 0.3, 1000);
                break;

            case 'level-up-background-music':
                backgroundMusicControls?.sound?.fade(0.3, 1, 1000);
                break;

            case 'play-login-intro':
                playLoginIntro();
                setTimeout(() => {
                    playBackgroundMusic();
                    backgroundMusicControls?.sound?.fade(0, 1, 2000);
                }, 16000);
                break;

            case 'stop-login-intro':
                loginIntroControls.stop();
                break;

            case 'play-avatar-music':
                backgroundMusicControls.pause();
                playAvatarMusic();
                break;

            case 'stop-avatar-music':
                avatarMusicControls.stop();
                break;

            case 'play-cuenca-baja-intro':
                backgroundMusicControls?.sound?.fade(1, 0, 1000);
                playCuencaBajaIntro();
                setTimeout(() => {
                    playBackgroundMusic();
                    backgroundMusicControls?.sound?.fade(0, 1, 2000);
                }, 20000);
                break;

            case 'stop-cuenca-baja-intro':
                cuencaBajaIntroControls.stop();
                break;

            case 'play-cuenca-media-intro':
                backgroundMusicControls?.sound?.fade(1, 0, 1000);
                playCuencaMediaIntro();
                setTimeout(() => {
                    playBackgroundMusic();
                    backgroundMusicControls?.sound?.fade(0, 1, 2000);
                }, 20000);
                break;

            case 'stop-cuenca-media-intro':
                cuencaMediaIntroControls.stop();
                break;

            case 'play-cuenca-alta-intro':
                backgroundMusicControls?.sound?.fade(1, 0, 1000);
                playCuencaAltaIntro();
                setTimeout(() => {
                    playBackgroundMusic();
                    backgroundMusicControls?.sound?.fade(0, 1, 2000);
                }, 42000);
                break;

            case 'stop-cuenca-alta-intro':
                cuencaAltaIntroControls.stop();
                break;

            case 'play-glaciar-intro':
                backgroundMusicControls?.sound?.fade(1, 0, 1000);
                playGlaciarIntro();
                setTimeout(() => {
                    playBackgroundMusic();
                    backgroundMusicControls?.sound?.fade(0, 1, 2000);
                }, 42000);
                break;

            case 'stop-glaciar-intro':
                glaciarIntroControls.stop();
                break;

            case 'play-pop-effect':
                playPop();
                break;

            case 'play-success-effect':
                playSuccess();
                break;

            case 'play-fail-effect':
                playFail();
                break;

            case 'play-victory-effect':
                playVictory();
                break;

            default:
                break;
        }
    };

    const handleSetAvatar = (seed: CharacterSeed) => {
        setGameState((currentGameState) => {
            return {
                ...currentGameState,
                avatarSeed: seed,
            };
        });
    };

    const handleSetPlayerName = (name: string) => {
        setGameState((currentGameState) => {
            return {
                ...currentGameState,
                playerName: name,
            };
        });
    };

    const handleSetPlayerScore = (score: number) => {
        setGameState((currentGameState) => {
            return {
                ...currentGameState,
                singlePlayerGameState: {
                    score,
                },
            };
        });
    };

    return (
        <GameContext.Provider
            value={{
                ...gameState,
                handleMainSound,
                handleSetAvatar,
                handleSetPlayerName,
                handleSetPlayerScore,
                handleDialogSound: {
                    sq__ca_2,
                    sq__ca_3,
                    sq__ca_familias,
                    sq__cm_descubrir,
                    sq__cm_lideres,
                    sq__cm_potencial,
                    sq__cm_sectores,
                    sq__cb_3,
                    sq__cb_desemboca,
                    sq__cb_nacimiento,
                    sq__gl_1,
                    sq__gl_2,
                    sq__gl_3,
                    sq__gl_6,
                    sq__gl_color,
                    sq__gl_glaciologia,
                    sq__gl_preocupacion,
                    sq__gl_sistema,
                    skin__danta,
                    skin__monkey,
                    skin__turkey,
                    skin__bird,
                },
            }}
        >
            <GameRouter />
            <div className="controls-music">
                <img
                    src={backgroundMusicControls?.sound?.playing() ? controlMusicOn : controlMusicOff}
                    alt="Control de música de fondo"
                    onClick={() =>
                        backgroundMusicControls?.sound?.playing()
                            ? backgroundMusicControls.stop()
                            : playBackgroundMusic()
                    }
                />
            </div>
        </GameContext.Provider>
    );
};

export default App;
